import { extendObservable, computed, observable } from "mobx";
import Autobind from "autobind-decorator";

@Autobind
class AuthModel {
  @observable
  _userID = "";

  @observable
  _userPassword = "";

  @observable
  // _isSignedIn = true;
  _isSignedIn = false;

  @observable
  _connectApp = "sarcopenia-ai";
  
  // JKS ADD 
  @observable
  _token: string | null = null;

  @observable
  _credit = 1000;

  @observable
  infer = false;

  @observable
  mask_infer = false;

  // get userToken() {
  //   return this._token;
  // }
  // set userToken(token) {
  //   this._token = token;
  // }

  get userID() {
    return this._userID;
  }
  set userID(userID) {
    this._userID = userID;
  }

  get userPassword() {
    return this._userPassword;
  }
  set userPassword(userPassword) {
    this._userPassword = userPassword;
  }

  get credit() {
    return this._credit;
  }
  set credit(credit) {
    this._credit = credit;
  }

  get isSignedIn() {
    return this._isSignedIn;
  }

  set isSignedIn(isSignedIn) {
    this._isSignedIn = isSignedIn;
  }

  get connectApp() {
    return this._connectApp;
  }

  set connectApp(connectApp) {
    this._connectApp = connectApp;
  }
}

export default AuthModel;
